<template>
  <div>
    <div>
      <img
        class="mainBackImg"
        :src="
          language
            ? require('@/assets/images/pilotService/questionnaireInvestigationBackImg.jpg')
            : require('@/assets/images/pilotService/en_questionnaireInvestigationBackImg.jpg')
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="20" :md="16" :lg="18" :xl="16">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="20" :md="16">
          <div class="top-title">{{ formData.survey_title }}</div>
          <div class="remark">{{ formData.survey_remark }}</div>
          <div v-for="(item, index) in formData.answer">
            <div
              v-if="item.active_option_set.length == 0 || item.active"
              class="contentBox"
            >
              <div class="box-top">
                <span class="title">{{ item.title }}</span>
                <span class="type">{{ questionType[item.type] }}</span>
              </div>
              <div v-if="item.type == 0" class="list">
                <el-radio-group
                  v-model="item.option_id"
                  @change="valueChange($event, item.id, item.type)"
                >
                  <div
                    v-for="eve in item.option_set"
                    :class="
                      item.option_id == eve.id ? 'activeList-one' : 'list-one'
                    "
                  >
                    <el-radio :label="eve.id">{{ eve.content }}</el-radio>
                  </div>
                </el-radio-group>
              </div>
              <div v-if="item.type == 1" class="list">
                <el-checkbox-group
                  v-model="item.option_id"
                  @change="valueChange($event, item.id, item.type)"
                >
                  <div
                    v-for="eve in item.option_set"
                    :class="
                      item.option_id.indexOf(eve.id) > -1
                        ? 'activeList-one'
                        : 'list-one'
                    "
                  >
                    <el-checkbox :label="eve.id" :key="eve.id">{{
                      eve.content
                    }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
              <div v-if="item.type == 2" class="list-one">
                <el-input
                  @change="valueChange($event, item.id, item.type)"
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6 }"
                  :placeholder="item.content"
                  v-model="item.content2"
                />
              </div>
              <div v-if="item.type == 3" class="list-one">
                <el-date-picker
                  v-model="item.content3"
                  @change="valueChange($event, item.id, item.type)"
                  type="date"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  :placeholder="item.content"
                  size="small"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="butt">
            <el-button
              style="background-color: #32589f; color: #ffffff; width: 200px"
              type="primary"
              plain
              round
              @click="sub"
            >
              提交
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  getAnswer,
  saveAnswer,
} from "@/api/pilotService/questionnaireInvestigation";
export default {
  data() {
    return {
      language: localStorage.getItem("language") || "zh",
      formData: {},
      form: {
        answer: [],
      },
      questionType: ["单选题", "多选题", "填空题", "填空题"],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      getAnswer({ id: this.$route.params.id })
        .then((res) => {
          if (res.code === 0) {
            res.data.answer.forEach((Element) => {
              Element.option_id = [];
              Element.content2 = "";
              Element.content3 = "";
            });
            this.formData = res.data;
          }
        })
        .catch((err) => {});
    },
    valueChange(id, question_id, type) {
      //判断激活显示
      for (const item of this.formData.answer) {
        if (item.active_option_set.length != 0) {
          if (type == 0) {
            if (item.active_option_set.indexOf(id) > -1) {
              this.$set(item, "active", true);
            }
          }

          if (type == 1) {
            for (const i of id) {
              if (item.active_option_set.indexOf(i) > -1) {
                this.$set(item, "active", true);
              }
            }
          }
        }
      }
      //
      let option_id = [];
      let content = "";
      if (type == 0) {
        option_id.push(id);
      }
      if (type == 1) {
        option_id = id;
      }
      if (type == 2 || type == 3) {
        content = id;
      }
      if (this.form.answer.length == 0) {
        this.form.answer.push({ option_id, question_id, content });
      } else {
        this.form.answer.forEach((Element) => {
          if (Element.question_id == question_id) {
            let index = this.form.answer.findIndex(
              (item) => item.question_id == question_id
            );
            this.form.answer.splice(index, 1);
          }
        });
        this.form.answer.push({ option_id, question_id, content });
      }
      this.checkArray();
    },
    checkArray() {
      let ids = [];
      this.form.answer.forEach((Element) => {
        for (const item of Element.option_id) {
          ids.push(item);
        }
      });
      this.formData.answer.forEach((Element) => {
        if (Element.active) {
          if (Element.active_option_set.length != 0) {
            // for (const item of Element.active_option_set) {
            //   if (ids.indexOf(item) == -1) {
            //
            //     this.$set(Element, "active", false);
            //   }
            // }
            if (Element.active_option_set.every((i) => ids.indexOf(i) == -1)) {
              this.$set(Element, "active", false);
              let num = this.form.answer.findIndex(
                (i) => i.question_id == Element.question_id
              );
              this.form.answer.splice(num, 1);
            }
          }
        }
      });
    },
    sub() {
      for (const item of this.formData.answer) {
        if (item.active_option_set.length == 0 || item.active) {
          if (
            (item.type == 0 || item.type == 1) &&
            item.option_id.length == 0
          ) {
            return this.$message.warning("请完所有题目");
          }
          if (item.type == 2 && item.content2 == "") {
            return this.$message.warning("请完所有题目");
          }
          if (item.type == 3 && item.content3 == "") {
            return this.$message.warning("请完所有题目");
          }
        }
      }
      saveAnswer({
        ...{ survey_id: this.$route.params.id },
        ...{ answer: this.form.answer },
      })
        .then((res) => {
          if (res.code === 0) {
            this.$message.success("提交成功");
            this.$router.go(-1);
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.mainBackImg {
  width: 100%;
  /* height: 300px; */
}
.container {
  padding: 20px;
}
.top-title {
  font-weight: 800;
  font-size: 21px;
  line-height: 60px;
}
.remark {
  font-size: 13px;
  color: #97989d;
}
.contentBox {
  margin: 20px 0;
  padding: 15px;
  border-radius: 10px;
  /* display: flex; */
  /* align-items: center; */
  background-color: #ffffff;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 20%);
}
.title {
  font-weight: 800;
  font-size: 16px;
}
.type {
  font-size: 12px;
  color: #97989d;
  margin-left: 15px;
}
.el-radio-group {
  display: block;
  padding: 0;
}

.list-one,
.activeList-one {
  margin-top: 15px;
  border-radius: 5px;
  background-color: #f7f7f7;
}

.activeList-one {
  background-color: #e1f6ff;
}

.list-one .el-radio,
.activeList-one .el-radio,
.list-one .el-checkbox,
.activeList-one .el-checkbox {
  padding: 8px 10px;
  display: block;
}

.butt {
  display: flex;
  justify-content: center;
  align-items: center;
}
.butt > .el-button {
  width: 60%;
}
@media only screen and (max-width: 768px) {
  .top-title {
    font-size: 16px;
  }
  .title {
    font-size: 14px;
  }
  .butt > .el-button {
    width: 100%;
  }
}
</style>